import Vue from "vue";
import Vuex from "vuex";

import auth from "./modules/auth";
import config from "./modules/config";
import report from "./modules/report";
import htmlClass from "./modules/htmlclass";
import breadcrumbs from "./modules/breadcrumbs";
import reportPicscan from './modules/report.picscan';
import reportTimeproof from './modules/report.timeproof';
import reportSignproof from './modules/report.signproof';
import reportScreenproof from './modules/report.screenproof';

Vue.use(Vuex);

export default new Vuex.Store({
   modules: {
      auth,
      report,
      config,
      htmlClass,
      breadcrumbs,
      reportPicscan,
      reportTimeproof,
      reportSignproof,
      reportScreenproof
   }
});
